import { cn } from '@glade-ai/ui';
import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import Calendar from '@/components/Icons/Calendar';

import Label from '../shared/Label';

import s from './DatePicker.module.scss';

export interface DatePickerProps {
  label: string;
  description?: string;
  hint?: string;
  placeholder?: string;
  required?: boolean;
  selected?: Date;
  onChange: (date: Date | null) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: string;
  hasError?: boolean;
  value: string | Date | null;
  disabled?: boolean;
  fixed?: boolean;
  min?: Date;
  max?: Date;
  showMonthYearPicker?: boolean;
  dateFormat?: string;
  compact?: boolean;
}

const CustomDatePicker: React.FC<DatePickerProps> = ({
  label,
  description,
  disabled,
  hint,
  placeholder = 'MM/DD/YYYY',
  required,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  hasError,
  fixed = true,
  min,
  max,
  showMonthYearPicker,
  dateFormat = 'MM/dd/yyyy',
  compact = false,
}) => (
  <div className={s.dateWrapper}>
    <Label
      label={label}
      required={required}
      description={description}
      errorMessage={error}
      hint={hint}
      compact={compact}
    >
      <div className={cn(s.wrapper, (hasError || !!error) && s.error)}>
        <DatePicker
          showIcon
          maxDate={max}
          minDate={min}
          showPopperArrow={false}
          selected={value ? new Date(value) : undefined}
          onChange={(date: Date | null) => onChange(date)}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholderText={placeholder}
          className={s.input}
          required={required}
          icon={<Calendar className={s.icon} />}
          disabled={disabled}
          showYearDropdown
          showMonthDropdown
          showMonthYearPicker={showMonthYearPicker}
          dateFormat={dateFormat}
          dropdownMode='select'
          popperProps={
            fixed
              ? {
                  strategy: 'fixed',
                }
              : undefined
          }
        />
      </div>
    </Label>
  </div>
);

export default CustomDatePicker;
